import axios from "axios";
import { store } from "./store/store.js";
import { deleteUser } from "./store/userStore.js";

// Session glissante de 30 minutes côté backend (15/09/2026) : sans ceci, un
// utilisateur inactif 30 minutes voyait ses écrans échouer en silence sur des
// 401 non gérés, plutôt que d'être ramené proprement à la connexion.
// `axios` est un singleton — enregistrer l'intercepteur une seule fois ici
// (importé par App.js) suffit à couvrir tous les appels de l'application,
// quel que soit le fichier qui les déclenche.
axios.interceptors.response.use(
  (reponse) => reponse,
  (erreur) => {
    const dejaConnecte = Boolean(store.getState().user?.value);
    if (erreur?.response?.status === 401 && dejaConnecte) {
      store.dispatch(deleteUser());
      sessionStorage.setItem("riseSessionExpiree", "1");
      window.location.href = "/";
    }
    return Promise.reject(erreur);
  }
);
